"use client";

import useAxiosAuth from "@/lib/hooks/useAxiosAuth";
import CWFButton from "@/components/ui/CWFButton";
import {useState} from "react";
import {useRouter} from "next/navigation";
import toast from "react-hot-toast";

export default function DiagoSync() {
    const axiosAuth = useAxiosAuth();
    const [isLoading, setIsLoading] = useState(false);
    const router = useRouter();


    function syncData(){
        setIsLoading(true);
        axiosAuth.post('diago/sync/diago')
            .then(res => {
                toast.success("Données récupérée avec succès")
                router.refresh();
            }).catch(err => {
                toast.error("Une erreur s'est produite")
        }).finally(() => {
            setIsLoading(false);
        })
    }
    return(
        <>
            <CWFButton loading={isLoading} onClick={() => syncData()}>
                Synchroniser mes données
            </CWFButton>
        </>
    )
}
